import React from 'react';
import {
	ILabel,
	IOrderInfoDetails,
	ITypeVignettesOrderManagementFields,
	formatPlates,
	getLabelValue,
} from '@adac-mp/shared';
import { ProductOrderSummary, renderProductIcon, renderProductSummaryElement } from '../index';

export const renderFlexServiceOrderSummary = (
	order: IOrderInfoDetails,
	labels: ITypeVignettesOrderManagementFields,
	generalLabels: ILabel[],
	withValidity?: boolean,
) => {
	const setOrderSummaryDetails = (withVal?: boolean) => {
		const orderSummaryDetails = [
			{
				id: 'licenseplate',
				label: getLabelValue('mp.licensePlate', generalLabels) || 'Kennzeichen',
				value: formatPlates(order.licenseplate),
			},
		];
		if (withVal) {
			orderSummaryDetails.unshift({
				id: 'validity',
				label: labels?.cart?.validity || 'Gültigkeit',
				value: labels?.untilRevoked || 'Bis auf Widerruf',
			});
		}
		return orderSummaryDetails;
	};
	return (
		<ProductOrderSummary
			simple
			expandable={false}
			wrapperClassName="mb-5"
			className="bg-white rounded-b-none px-1.5"
			order={order}
			title={order.serviceCatalogName}
			icon={renderProductIcon({
				moduleTypeId: order.moduleTypeId,
				supplierId: order.supplierId,
			})}>
			{renderProductSummaryElement(setOrderSummaryDetails(withValidity), order)}
		</ProductOrderSummary>
	);
};
